import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'pro' | 'admin'
}

/**
 * ProtectedRoute — Redirects to login if user is not authenticated.
 * Optionally enforces a minimum role level.
 */
export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const location = useLocation()
  const { accessToken, _refreshToken } = useAuthStore()
  
  // Check authentication: require JWT tokens (Firebase may be temporarily expired)
  // The backend validates JWTs independently, so we trust them even when
  // Firebase session is stale (e.g., background tab > 1 hour).
  if (!accessToken || !_refreshToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  
  // Role check (requires backend user role — currently checking Firebase email as placeholder)
  // Full role enforcement happens on the backend via JWT claims
  // This is a basic client-side guard
  if (requiredRole) {
    // For now, we trust the backend. Client-side role check would require
    // fetching user profile first. We'll add this once the /me endpoint works.
  }
  
  return <>{children}</>
}
